import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { Modal } from '@/components/Modal'

interface APYInfoModalProps {
  isOpen: boolean
  onClose: () => void
  apyPercentage?: number
}

export const APYInfoModal: React.FC<APYInfoModalProps> = ({
  isOpen,
  onClose,
  apyPercentage,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${t('translation:transferIn.APY')} ${apyPercentage ? `${apyPercentage}%` : ''}`}
    >
      <BaseView gap={32} p={16}>
        {/* APY Description */}
        <BaseText
          fontSize={16}
          fontFamily="regular"
          color="label.description"
          textAlign="center"
          style={{ lineHeight: 1.5 }}
        >
          {t('translation:transferIn.APYDescription')}
        </BaseText>

        {/* Confirm Button */}
        <AppButton label={t('form:actions.okay') || 'Okay'} onPress={onClose} />
      </BaseView>
    </Modal>
  )
}

export default APYInfoModal
